'use client';
import Link from 'next/link';
import React from 'react';

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  return (
    <footer className={`w-full bg-white ${className}`}>
      {/* ISO certification */}
      <div className="w-screen bg-gradient-to-b from-white from-50% to-black to-50% px-2">
        <div className="w-full max-w-7xl bg-white rounded-lg border border-[#E1EEFE] py-6 px-8 flex flex-col justify-center gap-16 mx-auto shadow-lg">
          <div className="flex flex-col sm:flex-row justify-between items-center self-stretch gap-6">
            <img
              src="/images/img_image_58_1.png"
              alt="Social Media Links"
              className="w-[82px] h-[88px] sm:w-[82px] sm:h-[88px]"
            />
            <span className="text-[#4D6896] sm:text-[1rem] te leading-[1.875rem]">
              Sixsense is proud to be ISO 27001 certified, reflecting our unwavering commitment to
              information security, reliability, and compliance — standards trusted by global
              semiconductor leaders.
            </span>
          </div>
        </div>
      </div>
      <div className={`w-full bg-[#000000] py-12`}>
        <div className="w-full max-w-7xl mx-auto px-1">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="flex sm:flex-col items-center sm:items-start justify-center sm:justify-start gap-4">
              {/* logo */}
              <div className="flex items-center gap-2.5">
                <img
                  src="/images/img_image_21.png"
                  alt="SixSense Logo"
                  className="w-[36px] h-[48px]"
                />
                <img
                  src="/images/img_image_20.png"
                  alt="SixSense Text"
                  className="hidden sm:block w-[60px] h-[48px] sm:w-[86px] sm:h-[48px]"
                />
              </div>
              {/* Address */}
              <p className="text-[#D7E3F1] text-[0.75rem] leading-[160%] sm:text-[1rem] font-normal font-ibm-plex sm:leading-8 max-w-lg">
                Sixsense, 21 Collyer Quay, Singapore 049320
              </p>
              {/* Copyright */}
              <p className="hidden sm:block text-[#D7E3F1] text-[0.75rem] leading-[160%] sm:text-[1rem] font-normal font-ibm-plex sm:leading-8 max-w-lg">
                Copyright © 2025.
              </p>
            </div>
            {/* Menu */}
            <div className="flex flex-col sm:flex-row justify-end items-center sm:items-end gap-6 sm:gap-20">
              {/* Pages */}
              <div className="flex sm:flex-col items-center sm:items-start justify-center sm:justify-start selection gap-12 sm:gap-4">
                <Link
                  href="/"
                  className="text-[#D7E3F1] text-[0.75rem] leading-[160%] sm:text-[1rem] font-normal font-ibm-plex sm:leading-8 max-w-lg"
                >
                  Home
                </Link>
                <Link
                  href="/product"
                  className="text-[#D7E3F1] text-[0.75rem] leading-[160%] sm:text-[1rem] font-normal font-ibm-plex sm:leading-8 max-w-lg"
                >
                  Product
                </Link>
                <Link
                  href="/about"
                  className="text-[#D7E3F1] text-[0.75rem] leading-[160%] sm:text-[1rem] font-normal font-ibm-plex sm:leading-8 max-w-lg"
                >
                  About Us
                </Link>
              </div>
              {/* Contact Info */}
              <div className="flex sm:flex-col justify-start gap-4">
                <p className="hidden sm:block text-[#D7E3F1] text-[0.75rem] leading-[160%] sm:text-[1rem] font-normal font-ibm-plex sm:leading-8 max-w-lg">
                  Contact us
                </p>
                <div className="flex items-center gap-3">
                  <svg
                    width="16"
                    height="24"
                    viewBox="0 0 16 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.59375 4.78125C0.25 4.875 0 5.15625 0 5.5C0 13.5312 6.5 20 14.5 20C14.875 20 15.1562 19.7812 15.25 19.4375L16 16.1875C16.0625 15.8438 15.9062 15.4688 15.5625 15.3125L12.0625 13.8125C11.75 13.6875 11.4062 13.7812 11.1875 14.0312L9.625 15.9375C7.1875 14.7812 5.21875 12.7812 4.09375 10.4062L6 8.84375C6.25 8.625 6.34375 8.28125 6.21875 7.96875L4.71875 4.46875C4.5625 4.125 4.1875 3.9375 3.84375 4.03125L0.59375 4.78125Z"
                      fill="white"
                    />
                  </svg>
                  <Link
                    href="tel:+65 94860203"
                    className="text-[#D7E3F1] text-[0.75rem] leading-[160%] sm:text-[1rem] font-normal font-ibm-plex sm:leading-8 max-w-lg"
                  >
                    +65 94860203
                  </Link>
                </div>
                <div className="flex items-center gap-3">
                  <svg
                    width="16"
                    height="12"
                    viewBox="0 0 16 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.3125 3.96875C0.1875 3.875 0 3.96875 0 4.125V10.5C0 11.3438 0.6875 12 1.5 12H14.5C15.3438 12 16 11.3438 16 10.5V4.125C16 3.96875 15.8438 3.875 15.7188 3.96875C15 4.53125 14.0938 5.21875 10.9062 7.53125C10.25 8 9.125 9.03125 8 9.03125C6.90625 9.03125 5.75 8 5.125 7.53125C1.9375 5.21875 1.03125 4.53125 0.3125 3.96875ZM8 8C8.75 8.03125 9.78125 7.09375 10.3125 6.71875C14.4688 3.71875 14.7812 3.4375 15.7188 2.6875C15.9062 2.5625 16 2.34375 16 2.09375V1.5C16 0.6875 15.3438 0 14.5 0H1.5C0.6875 0 0 0.6875 0 1.5V2.09375C0 2.34375 0.125 2.5625 0.3125 2.6875C1.25 3.4375 1.5625 3.71875 5.71875 6.71875C6.25 7.09375 7.28125 8.03125 8 8Z"
                      fill="white"
                    />
                  </svg>

                  <Link
                    href="mailto:hello@sixsense.ai"
                    className="text-[#D7E3F1] text-[0.75rem] leading-[160%] sm:text-[1rem] font-normal font-ibm-plex sm:leading-8 max-w-lg"
                  >
                    hello@sixsense.ai
                  </Link>
                </div>
                <div className="flex items-center gap-3">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.13375 14H0.23125V4.65292H3.13375V14ZM1.68094 3.37789C0.752813 3.37789 0 2.60912 0 1.68097C6.64312e-09 1.23515 0.177098 0.80759 0.492335 0.492346C0.807572 0.177102 1.23513 0 1.68094 0C2.12675 0 2.5543 0.177102 2.86954 0.492346C3.18478 0.80759 3.36188 1.23515 3.36188 1.68097C3.36188 2.60912 2.60875 3.37789 1.68094 3.37789ZM13.9969 14H11.1006V9.4499C11.1006 8.3655 11.0787 6.97484 9.59156 6.97484C8.0825 6.97484 7.85125 8.15299 7.85125 9.37177V14H4.95188V4.65292H7.73562V5.92794H7.77625C8.16375 5.19355 9.11031 4.41854 10.5225 4.41854C13.46 4.41854 14 6.35295 14 8.86551V14H13.9969Z"
                      fill="white"
                    />
                  </svg>

                  <Link
                    href="https://www.linkedin.com/company/sixsense-pte-ltd/posts/?feedView=all"
                    className="text-[#D7E3F1] text-[0.75rem] leading-[160%] sm:text-[1rem] font-normal font-ibm-plex sm:leading-8 max-w-lg"
                  >
                    Sixsense
                  </Link>
                </div>
              </div>
              {/* mobile copyright */}
              <div className="sm:hidden text-[#D7E3F1] leading-[160%] text-[0.75rem] font-normal font-ibm-plex">
                Copyright © 2025.
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
